import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import "./RechartsOverrides.scss";

const AnalyticsBarChart = ({ data, renderTooltip, tickFormatter, barKey1, barKey2, angle, textAnchor, textHeight, dx, dy, direction, axisLabelClass }) => {
    const values = data.map(d => d[barKey1]);
    const value2 = barKey2 && data.map(d => d[barKey2]);
    const min = barKey2 ? Math.min(...values, ...value2, 0) : Math.min(...values, 0);
    const max = barKey2 ? Math.max(...values, ...value2, 1) : Math.max(...values, 1);
    const isVertical = direction && direction === "vertical";

    //Generate whole number ticks between min and max
    const ticks = [];
    for (let i = Math.ceil(min); i <= Math.floor(max); i++) {
        ticks.push(i);
    }
    const MAX_VISIBLE_TICKS = 15;
    const interval = ticks.length > MAX_VISIBLE_TICKS
        ? Math.ceil(ticks.length / MAX_VISIBLE_TICKS) - 1
        : 0;
    // console.log("Ticks: ", ticks, interval);

    function onMouseEnter(e) {
        e.target.style.fillOpacity = '0.5';
    }

    function onMouseLeave(e) {
        e.target.style.fillOpacity = '1';
    }

    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart
                data={data}
                margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
                layout={isVertical ? 'vertical' : 'horizontal'}
            >
                {isVertical
                    ? <XAxis
                        type="number"
                        domain={[0, 'dataMax']}
                        ticks={ticks}
                        tickFormatter={tickFormatter ? value => tickFormatter(value) : undefined}
                        interval={interval}
                        dx={dx ? dx : 0}
                        dy={dy ? dy : 0}
                        className={axisLabelClass}
                    />
                    : <XAxis
                        dataKey="name"
                        angle={angle ? angle : 0}
                        textAnchor={textAnchor ? textAnchor : "middle"}
                        height={textHeight ? textHeight : 25}
                        dx={dx ? dx : 0}
                        dy={dy ? dy : 0}
                        className={axisLabelClass}
                    />
                }
                {isVertical
                    ? <YAxis
                        dataKey="name"
                        type="category"
                        width={105}
                        dx={dy ? -dy : 0}
                        dy={dx ? dx : 0}
                        className={axisLabelClass}
                    />
                    : <YAxis
                        ticks={null}
                        tickFormatter={tickFormatter ? value => tickFormatter(value) : undefined}
                        dx={dy ? -dy : 0}
                        dy={dx ? dx : 0}
                        className={axisLabelClass}
                    />
                }
                <CartesianGrid vertical={isVertical} horizontal={!isVertical} strokeDasharray="3 3" />
                <Tooltip content={renderTooltip} />
                <Bar type="monotone" dataKey="sessions" fill="#0E8EFD" onMouseEnter={(data, index, e) => onMouseEnter(e)} onMouseLeave={(data, index, e) => onMouseLeave(e)} />
                {barKey2 && <Bar type="monotone" dataKey={barKey2} fill="#62d9b7" onMouseEnter={(data, index, e) => onMouseEnter(e)} onMouseLeave={(data, index, e) => onMouseLeave(e)} />}
            </BarChart>
        </ResponsiveContainer>
    );
}

export default AnalyticsBarChart;